module.exports = __webpack_public_path__ + "img/empty.b09baba0.png";